module.exports = __webpack_public_path__ + "img/no-data-img.25969113.svg";